export function isServerError(status: number): boolean {
  return Math.floor(status / 100) === 5;
}
